import { render, staticRenderFns } from "./NewCreationPage.vue?vue&type=template&id=73a952a0&scoped=true&"
import script from "./NewCreationPage.vue?vue&type=script&lang=js&"
export * from "./NewCreationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a952a0",
  null
  
)

export default component.exports